import { render, staticRenderFns } from "./NewBlock.vue?vue&type=template&id=7e891c78&scoped=true&"
import script from "./NewBlock.vue?vue&type=script&lang=js&"
export * from "./NewBlock.vue?vue&type=script&lang=js&"
import style0 from "./NewBlock.vue?vue&type=style&index=0&id=7e891c78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e891c78",
  null
  
)

export default component.exports